import styled, { css } from 'styled-components';
import { common, space } from 'styles/css';

export const CustomBtn = styled.button`
  ${common}
  ${space}
  font-size:14px;
  white-space: pre;

  ${({ $type }) =>
    $type === 'text'
      ? css`
          background-color: transparent;
        `
      : $type === 'line'
        ? css`
            border: 1px solid ${({ theme }) => theme.colors.gray400};
            border-radius: 8px;
            background-color: white;
            color: ${({ theme }) => theme.colors.gray900};
            padding: 8px 24px 8px 16px;
          `
      : $type === 'badge'
        ? css`
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 2px solid transparent;
            border-radius: 100px;
            gap: 8px;
            padding: 8px 24px;
            font-size: 16px;
            font-weight: 700;
            line-height: 1;
            cursor: default;
            background-origin: border-box;
            background-clip: padding-box, border-box;

            /* $color 프롭에 따른 색상 분기 */
            ${({ $color }) => 
              $color === 'orange' 
              ? css`
                  background-color: rgba(255, 184, 140, 0.2);
                  color: #FF6450;
                  svg path { fill: #FF6450; stroke: #FF6450; }
                `
              : $color === 'red'
              ? css`
                  background-color: #FF383C; 
                  color: white; 
                  svg path { fill: #FF383C; stroke: #FF383C; }
                `
              : $color === 'mint'
              ? css`
                  background-color: #51E9C9; 
                  color: white; 
                  svg path { fill: #51E9C9; stroke: #51E9C9; }
                `  
              : css`
                  /* 기본 민트색 버전 (기존 유지) */
                  background-image: linear-gradient(#fff, #fff), linear-gradient(to right, #2fffbd, #96bce0);
                  background-color: #F0FDFB;
                  color: #2CD09C;
                  svg path { fill: #2CD09C; }
                `
            }
          `
        : $type === 'modal'
          ? css`
              border-radius: 8px;
              padding: 17px 24px;
              font-weight: 500;
              transition: all 150ms linear;
              color: white;
              background-color: ${({ theme }) => theme.colors.primary900};
            `
          : $type === 'cancel'
            ? css`
                border-radius: 8px;
                padding: 17px 64px;
                font-weight: 500;
                transition: all 150ms linear;
                background-color: white;
                color: ${({ theme }) => theme.colors.gray900};

                &:hover {
                background-color: ${({ theme }) => theme.colors.primary900};
              }
              `
            : css`
                border-radius: 8px;
                padding: 17px 24px;
                font-weight: 500;
                transition: all 150ms linear;
                color: white;
                background-color: ${({ theme }) => theme.colors.gray900};
              `
            }

  &:disabled {
    pointer-events: none;
  }
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;
